import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { CategoriaModel } from '../model/categoria.model';
import { EnvconfigService } from './envconfig.service';
import { EncryptDecryptService } from './EncryptDecryptService.service';
@Injectable({
    providedIn: 'root'
  })
  
  export class CategoriaService {
    categoriaItems : CategoriaModel[];
    constructor(protected http: HttpClient, 
      private router: Router,
      private environment: EnvconfigService,
      private encryptService: EncryptDecryptService) {
        this.categoriaItems = [];
        this.getCategoriaSistema();
    }
    getCategoriaSistema() {
      let _categoria_key = sessionStorage.getItem("menu")
      if (_categoria_key != null) {
        let bytes = this.encryptService.decrypt(_categoria_key, this.environment.get("keyCaptcha"));
        this.categoriaItems  = JSON.parse(bytes);
      }
      return this.categoriaItems;
    }

    getCategoriaSistemaPorNombre(searchName : string){
        let categorias: CategoriaModel[] = this.categoriaItems;
        searchName = searchName.toLocaleUpperCase();
        let result = categorias.filter(obj =>{ return obj.nombreCategoria.toLocaleUpperCase().includes(searchName)})
        if(result.length ===0){
            //segunda busqueda => sistema
            categorias = this.categoriaItems;
            result =  categorias.map(x => ({ idCategoria : x.idCategoria, codigoCategoria : x.codigoCategoria , nombreCategoria :x.nombreCategoria, listaSistema : x.listaSistema.filter(el =>el.nombreSistema.toLocaleUpperCase().includes(searchName)) })).filter(obj =>{ return obj.listaSistema.length>0 });
        }
        return result;
    }
  }